// Components
import SelectMenu from "../../react_components/select_menu";
import GoogleBannerAd from "../../react_components/ads/google_banner_ad";
import GoogleFeaturedContentModule from "../../react_components/ads/google_featured_content_module";

// Stores
import GoogleAdsStore from "../../react_stores/google_ads_store";
import ClickTrackingStore from "../../react_stores/click_tracking_store";

export const MobileGenresComponents = {
  SelectMenu,
  GoogleBannerAd,
  GoogleFeaturedContentModule,
};

export const MobileGenresStores = {
  GoogleAdsStore,
  ClickTrackingStore,
};
